export const Bio = {
  name: "V. Bhanu Teja",
  roles: [
    "Front-End Developer",
    "WordPress Developer",
    "UI/UX Designer",
    "Ethical Hacker",
    "Graphic Designer",
  ],
  description:
    "I am skilled in HTML, CSS, Bootstrap, React, WordPress, Git, AbobeXD, Figma, PHP, and, MySQL. With expertise in front-end development using HTML, CSS, and Bootstrap, I can create a visually appealing and responsive websites. Additionally, I am Proficient in React and PHP, enabling me to build interactive and dynamic user interfaces. My knowledge of wordpress allows me to design and customize websites efficiently, I am also familiar with git version control and AdobeXD and Figma for creating visually stunning mockups and prototypes.",
  github: "https://github.com/bhanut3ja",
  resume:
    "https://drive.google.com/file/d/1ffZrcMcn8UatXGIaautbbqpV7ADNaETA/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/hackerteja/",
  insta: "https://instagram.com/hackerteja/",
  // facebook: "#",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://images.ctfassets.net/qu3b5yecwxi8/48dbpUkzGMeo4mSQuwsUas/6d0793fa469c9b49e28e4840532e1b04/CSS3.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      // {
      //   name: "Redux",
      //   image:
      //     "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      // },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "PHP",
        image:
          "https://www.php.net//images/logos/new-php-logo.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "CMS",
    skills: [
      {
        name: "WordPress",
        image:
          "https://freepngimg.com/thumb/wordpress_logo/5-2-wordpress-logo-free-download-png.png",
      },
      {
        name: "Wix",
        image:
          "https://cdn4.iconfinder.com/data/icons/logos-and-brands/512/380_Wix_logo-512.png",
      },
    ],
  },
  {
    title: "Debugging Tools",
    skills: [
      {
        name: "Chrome Inspector",
        image:
          "https://www.google.com/chrome/static/images/chrome-logo-m100.svg",
      },
      {
        name: "Firebug",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/1/16/Firefox_logo%2C_2017.png/581px-Firefox_logo%2C_2017.png?20170928063359",
      },
    ],
  },
  {
    title: "Testing",
    skills: [
      {
        name: "Manual Testing",
        image:
          "https://enable.health.nsw.gov.au/__data/assets/image/0003/890301/UserGuide.png",
      },
    ],
  },
  {
    title: "Operating Systems",
    skills: [
      {
        name: "Kali Linux",
        image:
          "https://seeklogo.com/images/K/kali-linux-logo-AED181186E-seeklogo.com.png",
      },
      {
        name: "Windows",
        image:
          "https://logowik.com/content/uploads/images/windows-116906.jpg",
      },
    ],
  },
  {
    title: "Designing",
    skills: [
      {
        name: "PhotoShop",
        image:
          "https://www.adobe.com/content/dam/shared/images/product-icons/svg/photoshop.svg",
      },
      {
        name: "Illustrator",
        image:
          "https://logos-download.com/wp-content/uploads/2020/06/Adobe_Illustrator_Logo.png",
      },
      {
        name: "Adobe XD",
        image:
          "https://helpx.adobe.com/content/dam/help/mnemonics/xd_app_RGB_2017.svg",
      },
      {
        name: "Figma",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/33/Figma-logo.svg/400px-Figma-logo.svg.png",
      },
      {
        name: "Canva",
        image:
          "https://freelogopng.com/images/all_img/1656734305canva-app-icon.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Git_icon.svg/2048px-Git_icon.svg.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "WP Securities",
        image:
          "https://freepngimg.com/thumb/wordpress_logo/5-2-wordpress-logo-free-download-png.png",
      },
      
      {
        name: "WPRest API",
        image:
          "https://freepngimg.com/thumb/wordpress_logo/5-2-wordpress-logo-free-download-png.png",
      },     
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },      
      {
        name: "Postman",
        image:
          "https://voyager.postman.com/logo/postman-logo-icon-orange.svg",
      },
      {
        name: "Ethical Hacking",
        image:
          "https://th.bing.com/th/id/R.51c1569ead9ea881a66f303e0f1b0560?rik=z8Ew43AYoOOasA&riu=http%3a%2f%2fclipart-library.com%2fnew_gallery%2f90-903622_in-order-to-become-ethical-hacker-it-is.png&ehk=fi%2f3KCj6%2bsgiGXxK%2fXll%2fqdPKAdgyY51tb8Gsyh6t0Q%3d&risl=&pid=ImgRaw&r=0",
      },
     
     
    ],
  },
];

export const experiences = [
  // {
   // id: 0,
   // img: "https://media.licdn.com/dms/image/v2/D4D0BAQHrHFo1rsxWNw/company-logo_200_200/company-logo_200_200/0/1680247152522/makreate_logo?e=2147483647&v=beta&t=ti_3vr6YUFOGwUs6UPJ7GUk7SebMNg1OONN5lTzsYjk",
  //  role: "No-Code Developer",
  //  company: "Makreate",
 //   date: "Nov 2023 - Present ·  1 yrs 6 mos",
   // desc: "👋 Hello there, I’m Bhanu Teja, WordPress developer passionate about turning complex issues into simple, beautiful, and intuitive website designs.🌐💻 Font-end expert, quick learner, and team player - these traits best describe me. I'm also skilled in",
   // skills: [
  //    "HTML",
  //    "CSS",
    //  "Bootstrap",
  //    "JavaScript",
  //    "React",
   //   "PHP",
  //    "MySQL",
//      "FireBase",
 //    "WP Multisite",
  //    "Adobe XD",
  //    "Figma",
//    ],  
  // },

 // {
  //  id: 1,
  //  img: "https://skillinstituto.com/wp-content/uploads/2023/09/SIITS-Mockup-2.png",
 //   role: "Wordpress Developer",
 //   company: "Skill Instituto IT Services",
  //  date: "Nov 2019 - Oct 2023 · 4 yrs",
//    desc: "",
  //  skills: [
  //    "HTML",
 //     "CSS",
  //    "Bootstrap",
  //    "JavaScript",
 //     "React",
     // "PHP",
    //  "MySQL",
     // "FireBase",
      // "WP Multisite",
      // "Adobe XD",
   //   "Figma",
  //  ], 
  // },

];

export const education = [
  // {
  //   id: 0,
  //   img: "",
  //   school: "",
  //   date: "",
    
  //   desc: "",
  //   degree: "",
  // },
  // {
  //   id: 1,
  //   img: "#,
  //   school: "",
  //   date: "",
  //   grade: "",
  //   desc: "",
  //   degree: "",
  // },
  // {
  //   id: 2,
  //   img: "#,
  //   school: "",
  //   date: "",
  //   grade: "",
  //   desc: "",
  //   degree: "",
  // },
];

export const projects = [
  
  {
    id: 9,
    title: "Skill Instituto IT Services",
    date: "May 2019",
    description:
      "Skill Instituto IT Services is a web application designed to provide a good IT knowledge. It provides a IT Services and Virtual Internships.",
    
    tags: [
      "WordPress",
      "HTML",
      "CSS",
      "React JS",
      "PHP",
      "MySQL",
      "Elementor",
    ],
    category: "wordpress",
    github: "#",
    webapp: "https://skillinstituto.com/",
    member: [
      {
        name: "V Bhanu Teja",
        img: "https://img.freepik.com/premium-vector/male-face-avatar-icon-set-flat-design-social-media-profiles_1281173-3806.jpg?semt=ais_hybrid&w=740",
        linkedin: "https://www.linkedin.com/in/hackerteja/",
        github: "https://github.com/bhanut3ja/",
      },
    ],
  },
  {
    id: 18,
    title: "Orbis Cloud",
    date: "Jun 2025 - Jul 2025",
    description:
      "Empowering Healthcare with Tailored Solutions, Cyber Security & IT Managed Services.",
    
      tags: [ 
        "WordPress",
        "HTML",
        "CSS",
        "React JS",
        "PHP",
        "MySQL",
        "Elementor",
      ],
    category: "wordpress",
    github: "#",
    webapp: "https://orbiscloud.ae",
    member: [
      {
        name: "V Bhanu Teja",
        img: "https://img.freepik.com/premium-vector/male-face-avatar-icon-set-flat-design-social-media-profiles_1281173-3806.jpg?semt=ais_hybrid&w=740",
        linkedin: "https://www.linkedin.com/in/hackerteja/",
        github: "https://github.com/bhanut3ja/",
      },
    ],
  },
  {
    id: 12,
    title: "Shabbir Enterprices",
    date: "Dec 2023 - Jan 2024",
    description:
      "Our journey was inspired by the vision to provide all hardware solutions under one roof.",
    
      tags: [ 
        "WordPress",
        "HTML",
        "CSS",
        "React JS",
        "PHP",
        "MySQL",
        "Elementor",
      ],
    category: "wordpress",
    github: "#",
    webapp: "https://shabbirenterprises.com/",
    member: [
      {
        name: "V Bhanu Teja",
        img: "https://img.freepik.com/premium-vector/male-face-avatar-icon-set-flat-design-social-media-profiles_1281173-3806.jpg?semt=ais_hybrid&w=740",
        linkedin: "https://www.linkedin.com/in/hackerteja/",
        github: "https://github.com/bhanut3ja/",
      },
    ],
  },
  {
    id: 13,
    title: "Sabana Traders LLC",
    date: "Nov 2023 - Dec 2023",
    description:
      "Sabana Traders brings 50 years of expertise and knowledge in electrical equipment’s. We are one of UAE’s leading distributors for fuses, carbon brushes, heaters and insulation materials.",
    
      tags: [ 
        "WordPress",
        "HTML",
        "CSS",
        "React JS",
        "PHP",
        "MySQL",
        "Elementor",
      ],
    category: "wordpress",
    github: "#",
    webapp: "http://sabanatraders.com/",
    member: [
      {
        name: "V Bhanu Teja",
        img: "https://img.freepik.com/premium-vector/male-face-avatar-icon-set-flat-design-social-media-profiles_1281173-3806.jpg?semt=ais_hybrid&w=740",
        linkedin: "https://www.linkedin.com/in/hackerteja/",
        github: "https://github.com/bhanut3ja/",
      },
    ],
  },
  {
    id: 14,
    title: "SSE Metals",
    date: "Apr 2024 - May 2024",
    description:
      "SSE Metals specializes in a range of high-quality metal products including aluminum, stainless steel, and brass sheets, coils, and extrusions.We provide solutions for various industries such as construction, automotive, and manufacturing.",
    
      tags: [ 
        "WordPress",
        "HTML",
        "CSS",
        "React JS",
        "PHP",
        "MySQL",
        "Elementor",
      ],
    category: "wordpress",
    github: "#",
    webapp: "https://ssemetals.com/",
    member: [
      {
        name: "V Bhanu Teja",
        img: "https://img.freepik.com/premium-vector/male-face-avatar-icon-set-flat-design-social-media-profiles_1281173-3806.jpg?semt=ais_hybrid&w=740",
        linkedin: "https://www.linkedin.com/in/hackerteja/",
        github: "https://github.com/bhanut3ja/",
      },
    ],
  },
  {
    id: 15,
    title: "LIFMEX",
    date: "Apr 2024 - May 2024",
    description:
      "Lifmex Industries was established in 2010 with a strong focus on manufacturing lifting chains and their accessories. As time progressed and the quality of our brand was well-established in the market, it was time to have a larger prospect, aiming to have a global footprint in the category of lifting, rigging and material handling equipment.",
    
      tags: [ 
        "WordPress",
        "HTML",
        "CSS",
        "React JS",
        "PHP",
        "MySQL",
        "Elementor",
      ],
    category: "wordpress",
    github: "#",
    webapp: "https://lifmex.com/",
    member: [
      {
        name: "V Bhanu Teja",
        img: "https://img.freepik.com/premium-vector/male-face-avatar-icon-set-flat-design-social-media-profiles_1281173-3806.jpg?semt=ais_hybrid&w=740",
        linkedin: "https://www.linkedin.com/in/hackerteja/",
        github: "https://github.com/bhanut3ja/",
      },
    ],
  },
  {
    id: 16,
    title: "ITS YOSO",
    date: "Mar 2025",
    description:
      "The platform we wish we had, so we built it for you! YOSO redefines e-commerce where E stands for Experiential. We bridge the gap between online convenience and offline engagement, delivering a seamless shopping journey that combines the best of both worlds.",
    
      tags: [ 
        "WordPress",
        "HTML",
        "CSS",
        "React JS",
        "PHP",
        "MySQL",
        "Elementor",
      ],
    category: "wordpress",
    github: "#",
    webapp: "https://itsyoso.com/",
    member: [
      {
        name: "V Bhanu Teja",
        img: "https://img.freepik.com/premium-vector/male-face-avatar-icon-set-flat-design-social-media-profiles_1281173-3806.jpg?semt=ais_hybrid&w=740",
        linkedin: "https://www.linkedin.com/in/hackerteja/",
        github: "https://github.com/bhanut3ja/",
      },
    ],
  },
  {
    id: 17,
    title: "GCGT ( Golden Care General Trading )",
    date: "Dec 2024",
    description:
      "The business is a leading supplier of premium engineering materials for hospitality and facility management industries in Dubai. The business has been providing customized procurement and engineering solutions to clients since 1988.",
    
      tags: [ 
        "WordPress",
        "HTML",
        "CSS",
        "React JS",
        "PHP",
        "MySQL",
        "Elementor",
      ],
    category: "wordpress",
    github: "#",
    webapp: "https://gcgtdxb.com/",
    member: [
      {
        name: "V Bhanu Teja",
        img: "https://img.freepik.com/premium-vector/male-face-avatar-icon-set-flat-design-social-media-profiles_1281173-3806.jpg?semt=ais_hybrid&w=740",
        linkedin: "https://www.linkedin.com/in/hackerteja/",
        github: "https://github.com/bhanut3ja/",
      },
    ],
  },
  {
    id: 0,
    title: "Cyber Software Solutions",
    date: "Feb 2022 - Feb 2022",
    description:
      "Cyber Software Institute (CSI) is the only institution to provide end-to-end training to students. It was started with a vision to bridge the skill gap in the cyber security domain by creating with security professionals.",
   
    tags: [ 
    "WordPress",
    "HTML",
    "CSS",
    "React JS",
    "PHP",
    "MySQL",
    "Elementor",],
    category: "wordpress",
    github: "#",
    webapp: "https://csisolutions.in/",
    member: [
      {
        name: "V Bhanu Teja",
        img: "https://img.freepik.com/premium-vector/male-face-avatar-icon-set-flat-design-social-media-profiles_1281173-3806.jpg?semt=ais_hybrid&w=740",
        linkedin: "https://www.linkedin.com/in/hackerteja/",
        github: "https://github.com/bhanut3ja/",
      },
    ],
  },
  {
    id: 1,
    title: "Learning Myriad",
    date: "Nov 2022 - Nov 2022",
    description:
      "At Learning Myriad, We offer the best E-Learning solutions to all yours learning needs. We extend our services i.e edutional and corporate training for the higher educations institutions, corporate, and government agencies of any...",
    
      tags: [ 
        "WordPress",
        "HTML",
        "CSS",
        "React JS",
        "PHP",
        "MySQL",
        "Elementor",
      ],
    category: "wordpress",
    github: "#",
    webapp: "https://learningmyriad.com/",
    member: [
      {
        name: "V Bhanu Teja",
        img: "https://img.freepik.com/premium-vector/male-face-avatar-icon-set-flat-design-social-media-profiles_1281173-3806.jpg?semt=ais_hybrid&w=740",
        linkedin: "https://www.linkedin.com/in/hackerteja/",
        github: "https://github.com/bhanut3ja/",
      },
    ],
  },
  {
    id: 2,
    title: "Rainbow Water Purifier",
    date: "Jul 2018 - Jul 2018",
    description:
      "All kinds of water purifiers available (Domestic and Commercial). All types of water purifying plants sales & services.  Supply through all over INDIA.",
   
      tags: [ 
        "WordPress",
        "HTML",
        "CSS",
        "React JS",
        "PHP",
        "MySQL",
        "Elementor",
      ],
    category: "wordpress",
    github: "#",
    webapp: "http://rainbowwaterpurifier.epizy.com/",
    member: [
      {
        name: "V Bhanu Teja",
        img: "https://img.freepik.com/premium-vector/male-face-avatar-icon-set-flat-design-social-media-profiles_1281173-3806.jpg?semt=ais_hybrid&w=740",
        linkedin: "https://www.linkedin.com/in/hackerteja/",
        github: "https://github.com/bhanut3ja/",
      },
    ],
  },
  {
    id: 3,
    title: "Best Careers India",
    date: "Feb 2021 - Feb 2021",
    description:
      "Best Careers India is a leading Business services provider, leveraging our extensive domain knowledge and future-ready digital platforms to drive client productivity through Quality solutions.",
   tags: [ 
        "WordPress",
        "HTML",
        "CSS",
        "React JS",
        "PHP",
        "MySQL",
        "Elementor",
      ],
    category: "wordpress",
    github: "#",
    webapp: "https://bestcareersindia.com/",
    member: [
      {
        name: "V Bhanu Teja",
        img: "https://img.freepik.com/premium-vector/male-face-avatar-icon-set-flat-design-social-media-profiles_1281173-3806.jpg?semt=ais_hybrid&w=740",
        linkedin: "https://www.linkedin.com/in/hackerteja/",
        github: "https://github.com/bhanut3ja/",
      },
    ],
  },
  {
    id: 10,
    title: "Lapdoc",
    date: "Aug 2019 - Aug 2019",
    description:
      "We are specialized in laptop service and have repaired thousands of laptops with 100s of different laptop issues. Starting from Keyboard issues to the Motherboard Chip level of services. We can fix it All! as long as it can be fixed",
    
      tags: [ 
        "WordPress",
        "HTML",
        "CSS",
        "React JS",
        "PHP",
        "MySQL",
        "Elementor",
      ],
    category: "wordpress",
    github: "#",
    webapp: "https://www.lapdoc.in/",
    member: [
      {
        name: "V Bhanu Teja",
        img: "https://img.freepik.com/premium-vector/male-face-avatar-icon-set-flat-design-social-media-profiles_1281173-3806.jpg?semt=ais_hybrid&w=740",
        linkedin: "https://www.linkedin.com/in/hackerteja/",
        github: "https://github.com/bhanut3ja/",
      },
    ],
  },
  
  // React
  {
    id: 4,
    title: "Cybershah Software Solutions",
    date: "Jul 2023",
    description:
      "Welcome to the Cybershah Software Solutions, The cybershah software solutions. In an era marked by escalating cyber threats targeting businesses, the urgency to invest in cybersecurity education has never been greater.",
    
    tags: ["React Js", "Firebase"],
    category: "wordpress",
    github: "#",
    webapp: "https://cybershahsoftwaresolutions.com/",
    member: [
      {
        name: "V Bhanu Teja",
        img: "https://img.freepik.com/premium-vector/male-face-avatar-icon-set-flat-design-social-media-profiles_1281173-3806.jpg?semt=ais_hybrid&w=740",
        linkedin: "https://www.linkedin.com/in/hackerteja/",
        github: "https://github.com/bhanut3ja/",
      },
    ],
  },
  {
    id: 5,
    title: "Jc Law Logics",
    date: "May 2022 - May 2022",
    description:
      "JC LAW LOGICS is First-Class Family Advocate & Legal Advisor. Provide Counceling...",
    
      tags: [ 
        "WordPress",
        "HTML",
        "CSS",
        "React JS",
        "PHP",
        "MySQL",
        "Elementor",
      ],
    category: "wordpress",
    
    member: [
      {
        name: "V Bhanu Teja",
        img: "https://img.freepik.com/premium-vector/male-face-avatar-icon-set-flat-design-social-media-profiles_1281173-3806.jpg?semt=ais_hybrid&w=740",
        linkedin: "https://www.linkedin.com/in/hackerteja/",
        github: "https://github.com/bhanut3ja/",
      },
    ],
  },
  {
    id: 6,
    title: "Fantacy Lab",
    date: "Jun 2022 - Jun 2022",
    description:
      "Fantasy Lab is a collection of artists and visionaries who collaborate together to create stories with life and unique experiences. Seven spaces (Illumination, Delirium, Kaleidoscope, Nightmare, Circus, Labyrinth, Stars) shelter various emotions and sensations, reaching the subconscious where each person will experience different feelings such as nostalgia, madness, and even fear.",
   
      tags: [ 
        "WordPress",
        "HTML",
        "CSS",
        "React JS",
        "PHP",
        "MySQL",
        "Elementor",
      ],
    category: "wordpress",
    github: "#",
    webapp: "https://fantasylab.mx/",
    member: [
      {
        name: "V Bhanu Teja",
        img: "https://img.freepik.com/premium-vector/male-face-avatar-icon-set-flat-design-social-media-profiles_1281173-3806.jpg?semt=ais_hybrid&w=740",
        linkedin: "https://www.linkedin.com/in/hackerteja/",
        github: "https://github.com/bhanut3ja/",
      },
    ],
  },
  {
    title: "Dane Partners",
    date: "Jun 2022 - Jun 2022",
    description:
      "Fantasy Lab is a collection of artists and visionaries who collaborate together to create stories with life and unique experiences. Seven spaces (Illumination, Delirium, Kaleidoscope, Nightmare, Circus, Labyrinth, Stars) shelter various emotions and sensations, reaching the subconscious where each person will experience different feelings such as nostalgia, madness, and even fear.",
    
      tags: [ 
        "WordPress",
        "HTML",
        "CSS",
        "React JS",
        "PHP",
        "MySQL",
        "Elementor",
      ],
    category: "wordpress",
    github: "#",
    webapp: "https://fantasylab.mx/",
    member: [
      {
        name: "V Bhanu Teja",
        img: "https://img.freepik.com/premium-vector/male-face-avatar-icon-set-flat-design-social-media-profiles_1281173-3806.jpg?semt=ais_hybrid&w=740",
        linkedin: "https://www.linkedin.com/in/hackerteja/",
        github: "https://github.com/bhanut3ja/",
      },
    ],
  },
  {
    title: "My DNA Book",
    date: "Jun 2022 - Jun 2022",
    description:
      "MY DNA BOOK is focused on preventive health-care through healthy habits.",
    
    tags: [ 
        "WordPress",
        "HTML",
        "CSS",
        "React JS",
        "PHP",
        "MySQL",
        "Elementor",
      ],
    category: "wordpress",
    
    member: [
      {
        name: "V Bhanu Teja",
        img: "https://img.freepik.com/premium-vector/male-face-avatar-icon-set-flat-design-social-media-profiles_1281173-3806.jpg?semt=ais_hybrid&w=740",
        linkedin: "https://www.linkedin.com/in/hackerteja/",
        github: "https://github.com/bhanut3ja/",
      },
    ],
  },

  // PHP
  {
    id: 7,
    title: "Eazy Share",
    date: "Dec 2022 - Jan 2023",
    description:
      "Eazy Share is a free, clients-oriented, private file sharing web application.",
   
    tags: ["PHP", "MySQL",],
    category: "php",
    github: "#",
    webapp: "https://eazy-share.skillinstituto.com/",
    member: [
      {
        name: "V Bhanu Teja",
        img: "https://img.freepik.com/premium-vector/male-face-avatar-icon-set-flat-design-social-media-profiles_1281173-3806.jpg?semt=ais_hybrid&w=740",
        linkedin: "https://www.linkedin.com/in/hackerteja/",
        github: "https://github.com/bhanut3ja/",
      },
    ],
  },
  {
    id: 8,
    title: "Certificate Verification",
    date: "Jan 2019",
    description:
      "Scan Qr to Verify Your Certificate",
   
    tags: ["PHP", "Excel", "PhotoShop",],
    category: "php",
    github: "#",
    webapp: "https://verify.skillinstituto.com/",
    member: [
      {
        name: "V Bhanu Teja",
        img: "https://img.freepik.com/premium-vector/male-face-avatar-icon-set-flat-design-social-media-profiles_1281173-3806.jpg?semt=ais_hybrid&w=740",
        linkedin: "https://www.linkedin.com/in/hackerteja/",
        github: "https://github.com/bhanut3ja/",
      },
    ],
  },
  {
    id: 9,
    title: "FinVedic",
    date: "Nov 2022",
    description:
      "Finvedic is a FinTech based EdTech platform that specializes in offering trainings on FinTech",
    tags: ["Adobe XD", "PhotoShop"],
    category: "uidesign",
    github: "#",
    webapp: "https://xd.adobe.com/view/1b99632d-0090-4784-aafe-29725154f1d8-4eca/",
    member: [
      {
        name: "V Bhanu Teja",
        img: "https://img.freepik.com/premium-vector/male-face-avatar-icon-set-flat-design-social-media-profiles_1281173-3806.jpg?semt=ais_hybrid&w=740",
        linkedin: "https://www.linkedin.com/in/hackerteja/",
        github: "https://github.com/bhanut3ja/",
      },
    ],
  },
];

